<template>
  <vueGraph :colors="colors"></vueGraph>
   <div id="controls">
    <FaqExpandable>
      <template #header>
        Filters
      </template>
      <template #default>
        <!-- <input type="radio" id="ra-s-t" name="set" checked><a><span :style="{'background-color': this.colors.S_color}">Societal and behavioural</span> vs <span :style="{'background-color': this.colors.T_color}">Technical</span></a><br>
        <input type="radio" id="ra-hie" name="set"><a>Mitigation type</a><br>
        <input type="radio" id="ra-sec" name="set"><span>Sector</span><br> -->
        <hr style="height:1px;border-width:0;color:#d0d0f0;background-color:#d0d0f0">
        <p>
          Only show entities with more than
        </p>
        <input id="filter-nodes" type="number" style="font-family: 'Courier New', Courier, monospace; font-size: 18px;"
      placeholder="0" min="0">
        <p>
          projects.
        </p>
        <hr style="height:1px;border-width:0;color:#d0d0f0;background-color:#d0d0f0">


        <p>
          Highlight pairs with more than
        </p>
        <input id="filter-edges" type="number" style="font-family: 'Courier New', Courier, monospace; font-size: 18px;"
      placeholder="0" min="0">
        <p>
          projects in common.
        </p>
        <hr style="height:1px;border-width:0;color:#d0d0f0;background-color:#d0d0f0"><br>

      </template>
    </FaqExpandable>
    <FaqExpandable>
      <template #header>
        Search entities
      </template>
      <template #default>

        <input id="search-input" type="text" style="font-family: 'Courier New', Courier, monospace; font-size: 18px;"
      placeholder="search"><br><br>
      </template>
    </FaqExpandable>
    <FaqExpandable>
      <template #header>
        Explanation
      </template>
      <template #default>
        <p>This is a visualisation of the entities in the European Commission's <a href="https://cordis.europa.eu/" target="_blank">CORDIS database</a>, with a cutoff date of 24 September 2024. You can filter to see only the entities with the most connections or the pairs of entities with the most projects together. 
          <br><br>The area of the dot is proportional to the number of CCUS projects the entity is involved in, and the thickness of the edge is proportional to how many common projects between a pair of entities. Data is from <a href="https://www.solid-sustainability.org/ccus-tables" target="_blank">here</a>.
          <br><br>In the bottom right quadrant are fossil fuel companies, state-funded fossil-fuel research is in the bottom left, foundations, institutes or consortia with both public and fossil fuel interests are on the top right. All other entities, including universities and non-fossil fuel companies, are in the top left.</p>


        <p >❓ <a href="https://docs.google.com/document/d/1NiF0QlLXE0JO2W_wVhwIbCF8ouDhxIekk-AlVNZs-F4/edit?usp=sharing" target="_blank" style="color: black;">Read more on our methodology for classifiying fossil fuel and other entities</a></p>
        <p >❓ <a href="https://docs.google.com/document/d/1rN__SIVLM7bg9UarAHInmto4IbSU8R-SMA2pNCmpCyY/edit?usp=sharing" target="_blank" style="color: black;">Read more on how we classified CCUS</a></p>

        



      </template>
    </FaqExpandable><br>
  </div> 
</template>

<script>
import vueGraph from './components/vueGraph.vue'
import FaqExpandable from './components/FaqExpandable.vue'

export default {
  name: 'app',
  components: {
    vueGraph,
    FaqExpandable
  },
  data() {
    return {
      colors: {
            "S_color": '#a0a0f0',
            "T_color": '#f0d080',
            "u_color": '#404040',
            "uk_color": '#d0d0d0',
            "avoid_color": '#10b0b0',
            "rehabilitate_color": '#d010d0',
            "offset_color": '#c0a010',
            "replace_color": '#3030b0',
            "minimise_color": '#b07050',
            "Built_environment_color": '#a0a0a0',
            "Education_color": '#a030a0',
            "Energy_color": '#30a0a0',
            "LULUCF_color": '#a0a030',
            "Transport_color": '#3030a0',
            "Finance_color": '#30a030',
            "Geoengineering_color": '#a03040',
            "Industry_color": '#a06020',
            "listOfSectors": ['Built environment', 'Education', 'Energy', 'Finance', 'Geoengineering', 'Industry', 'LULUCF', 'Transport'],
            "listTechSocial": ['S', 'T'],
            "listOfHierarchy": ['avoid', 'replace', 'rehabilitate', 'minimise', 'offset'],
      },
      listSectorIds: ['cb-bui', 'cb-edu', 'cb-ene', 'cb-fin', 'cb-geo', 'cb-ind', 'cb-lan', 'cb-tra'],
      listHierarchyIds: ['cb-avo', 'cb-rep', 'cb-reh', 'cb-min', 'cb-off'],

    }
  },
  computed: {
    sector_opts() { return [this.colors.Built_environment_color, this.colors.Education_color, this.colors.Energy_color, this.colors.Finance_color, this.colors.Geoengineering_color, this.colors.Industry_color, this.colors.LULUCF_color, this.colors.Transport_color]},
    t_s_opts() {return [this.colors.S_color, this.colors.T_color]},
    hierarchy_opts() {return [this.colors.avoid_color, this.colors.replace_color, this.colors.rehabilitate_color, this.colors.minimise_color, this.colors.offset_color]},

  }

}



</script>

<style></style>
